const getOwnValue = (obj: object, key: string): unknown => {
  const desc = Object.getOwnPropertyDescriptor(obj, key);
  if (desc?.get) {
    return desc.get.call(obj);
  }
  return desc?.value;
};

export const deepEqual = (a: unknown, b: unknown): boolean => {
  if (a === b) {
    return true;
  }

  if (a == null || b == null) {
    return false;
  }

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  if (typeof a !== 'object' || typeof b !== 'object') {
    return false;
  }

  if (Array.isArray(a) !== Array.isArray(b)) {
    return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((item, i) => deepEqual(item, b[i]));
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  return keysA.every(
    key =>
      keysB.includes(key) && deepEqual(getOwnValue(a, key), getOwnValue(b, key))
  );
};
